import {
  Navigate,
  Outlet,
  RouteObject
} from 'react-router-dom';

import { useSubscriptionGuardQuery } from 'generated/graphql';
import { OrganizationLayout } from './Layout/OrganizationLayout';
import { OrganizationSettingsActivity } from './OrganizationSettingsActivity/OrganizationSettingsActivity';
import { SubscriptionActivity } from './SubscriptionActivity/SubscriptionActivity';
import { UsersActivity } from './UsersActivity/UsersActivity';



export const root: RouteObject = {
  path: 'account',
  element: (
    <OrganizationLayout />
  ),
  children: [{
    path: ':organizationId',
    element: (
      <Outlet />
    ),
    children: [
      {
        path: '',
        index: true,
        element: <SubscriptionRedirect />
      },
      {
        path: 'settings',
        element: <OrganizationSettingsActivity />
      },
      {
        path: 'subscription',
        element: <SubscriptionActivity />
      },
      {
        path: 'users',
        element: <UsersActivity />
      },
      {
        path: '*',
        element: <Navigate to='settings' />
      }
    ]
  }]
};



function SubscriptionRedirect() {
  const { data, loading } = useSubscriptionGuardQuery();
  if (loading) {
    return null;
  }

  const hasActive = data?.loggedInUser?.person.memberships.some((o) => o.organization.hasActiveSubscription);

  if (hasActive) {
    return <Navigate to='settings' />;

  }

  return <Navigate to='subscription' />;
}
